import * as React from 'react';
import { InStateExpenditureBoxPlotChart } from '../../../interface/MyInterfaces';
//import { numberWithCommas } from '../../Common/Helpers';
import { d3BoxPlot } from '../../Reports/Viz/d3BoxPlot';



export class InStateExpenditureBoxPlot extends React.Component<InStateExpenditureBoxPlotChart, {}> {
    svg_id: string = "boxplot";
    loading_id: string = "boxplot_loading";
    width: number = 400;
    height: number = 340;

    componentDidMount() {
        let d3chart = new d3BoxPlot(this.svg_id, this.loading_id,this.width, this.height);
        if (this.props.SpendingInStateExpenditureBoxPlot !== undefined
            && this.props.SpendingExpenditureTable2 !== undefined) {
            var in_state_pct = this.props.SpendingExpenditureTable2.in_state_pct / 100;
            var all_others = this.props.SpendingInStateExpenditureBoxPlot;
            var bench_year = this.props.FilterState.bench_year;
            var the_university = this.props.FilterState.Initial_the_university.replace("the ", "");

            d3chart.drawChart(in_state_pct, all_others, bench_year, the_university);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (//nextProps.SpendingInStateExpenditureBoxPlot !== this.props.SpendingInStateExpenditureBoxPlot &&
            nextProps.SpendingInStateExpenditureBoxPlot !== undefined &&
            //nextProps.SpendingExpenditureTable2 !== this.props.SpendingExpenditureTable2 &&
            nextProps.SpendingExpenditureTable2 !== undefined) {
            let d3chart = new d3BoxPlot(this.svg_id, this.loading_id, this.width, this.height);

            var in_state_pct = nextProps.SpendingExpenditureTable2.in_state_pct / 100;
            var all_others = nextProps.SpendingInStateExpenditureBoxPlot;
            var bench_year = nextProps.FilterState.bench_year;
            var the_university = nextProps.FilterState.Initial_the_university.replace("the ", "");
            d3chart.drawChart(in_state_pct, all_others, bench_year, the_university);
        }
    }

    render() {
        return <div className="boxplot">
            <label id="boxplot_loading">loading <i className="fa fa-spinner"></i></label>
            <svg id="boxplot"></svg>
        </div>
    }
}